import { Box, useMediaQuery } from '@mui/material';
import gaiaTheme from '../../../root-components/theme';
import { SettingsMobileNavbar } from '../../../root-components/navigation/settings-mobile-navbar';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { ScreenLabelForm } from '../../presentation-components/settings-components/screen-label-form';
import { useState, useEffect, useContext } from 'react';
import ScreenLabelsService from '../../../shared/services/screen-labels/screen-labels.service';
import { IScreenLabel } from '../../../shared/services/screen-labels/screen-labels.model';
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications';
import { ScreenLabelsContext } from '../../../context/screen-labels/screen-labels';

export const SettingsScreenLabelPage = () => {
  //Services
  const screenLabelsService = new ScreenLabelsService();
  const userNotificationsContext = useContext(UserNotificationsContext);
  const screenLabelsContext = useContext(ScreenLabelsContext);
  //State
  const [editField, setEditField] = useState<string>('');
  const [screenLabels, setScreenLabels] = useState<IScreenLabel[]>([]);
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  //Effects
  useEffect(() => {
    getScreenLabels();
  }, []);

  //Functions
  const getScreenLabels = async () => {
    try {
      const labels = await screenLabelsService.getAll();
      setScreenLabels(labels);
    } catch (error) {
      console.error('Error fetching screen labels:', error);
    } finally {
    }
  };

  const handleSubmit = async (formData: { [key: string]: string | null }) => {
    try {
      await screenLabelsService.createOrUpdate(formData);
      userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
      await getScreenLabels();
      await screenLabelsContext.forceUpdateLabels();
    } catch (error) {
      userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
      console.error(error);
    }
  };
  return (
    <PageOuterContainer>
      {isMobileMode && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <PageHeading
        title='Custom Screen Labels'
        hasTabs={false}
      />
      {screenLabels && <ScreenLabelForm
        submitHandler={handleSubmit}
        editField={editField}
        setEditField={setEditField}
        screenLabels={screenLabels}
      />}
    </PageOuterContainer>
  )
}